export default __webpack_public_path__ + "static/media/yard-bg.3d4b686b.png";